// A product's own code, made from its name when nobody types one. The import and the
// product form share it, so a product named the same way gets the same code either way.

/** "Wai Wai Noodles 75g" → "WAI-WAI-NOODLES-75G" (deterministic, so re-imports match). */
export function skuFromName(name: string): string {
  const slug = name
    .normalize('NFKD')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 24)
    .replace(/-+$/g, '')
  return slug || 'ITEM'
}

/**
 * The first free code for a name: the name's own code, then "-2", "-3"… while `taken` says
 * a code is in use. SKUs are unique in a business whatever their case.
 */
export async function nextSku(
  name: string,
  taken: (sku: string) => boolean | Promise<boolean>,
): Promise<string> {
  const base = skuFromName(name)
  if (!(await taken(base))) return base
  for (let n = 2; n < 1000; n++) {
    const candidate = `${base}-${n}`
    if (!(await taken(candidate))) return candidate
  }
  return `${base}-${Date.now().toString(36).toUpperCase()}`
}
